import exclamationIcon from "../../src/assets/images/error.svg";
import warningIcon from "../../src/assets/images/disclaim.svg";
export const LOGIN = {
    otp_selection: 'OTP_TARGET_SELECTION_REQUIRED',
    otp_validation_required: 'OTP_VALIDATION_REQUIRED',
    password_reset_required: 'PASSWORD_RESET_REQUIRED',
    resume: 'RESUME',
    suspended: 'Suspended',
    auth_failed: 'Authentication Failed.',
    try_agin: 'Please try again.',
    invalid_password: 'Invalid username/password',
    invalid_credential: 'Login Failed. Please try again.',
    account_suspended: 'Account Suspended. Please check and try again.',
    user_information: 'We did not recognize the information',
    technical_issue: 'We are facing some technical issue. Please try again after some time.',
    default_error_message: 'Something went wrong. Click Ok to reload.'
};
export const COOKIES_NAME = 'PA.APP_RTL_LTO_01';
export const EXTERNAL_COOKIES_NAME = 'APP_LTOVF_IDMAPPING';
export const TOAST_CONFIG = {
    formError: {
        message: "Your application is currently being worked on by another user. Please reach out to your sales representative. ",
        icon: warningIcon,
        backgroundColor : "#fde8d7",
        textColor: "#F58025"
    },
    userConflict : {
        message: "The deal is not assigned to you. Please contact the PNC Sales Rep.",
        icon: warningIcon,
        backgroundColor : "#fde8d7",
        textColor: "#F58025"
    }
}

export const autoDocsEmailToParterner =  "Auto Docs Emailed to Partner";
export const sales_queue_Path = "sales-queue/postApplication";
export const PATH_DEAL_STATUS = [
    {
        'path':'credit-app/portal-dashboard',
        'status': ['More Information Requested' , 'Saved'],
        'type' : 'show'
    },
    {
        'path':'underwritting/credit-work-queue',
        'status': ['Saved','Booked'],
        'type' : 'dontShow'
    },
    {
        'path':'underwriting/credit-details',
        'status': ['Saved','Booked'],
        'type' : 'dontShow'
    },
    {
        'path':'underwriting/list-of-similars',
        'status': ['Saved','Booked'], // status in which assignreassign will not comes up .
        'type' : 'dontShow'
    },
    {
        'path':'credit-app/additional-information',
        'status': ['More Information Requested' , 'Saved'],
        'type' : 'show'
    },
     {
        'path':'sales-support/postApplication',
        'status': ['Credit-Approved Auto Docs','Credit-Approved','Credit-Conditional Approved','Change Request - Accepted','Change Request - Rejected', 'Change Request - Partially Accepted',
                    'Post Application Review Complete','Pricing Review','Pricing Complete','Auto Docs Emailed to Partner','Docs Received - In Review','Docs Back / Missing Information',
                    'Docs Resubmitted - In Review','eDocs Requested','Docs Sent Out to Customer','Auto Docs Signed'],
        'type' : 'show'
    },
    {
        'path':'sales-queue/postApplication',
        'status': ['Credit-Approved Auto Docs','Credit-Approved','Credit-Conditional Approved','Change Request - Accepted','Change Request - Rejected', 'Change Request - Partially Accepted',
                    'Post Application Review Complete','Pricing Review','Pricing Complete','Auto Docs Emailed to Partner','Docs Back / Missing Information',],
        'type' : 'show'
    }

]

export const USER_CONFLICTS = {
    CheckAssignment : 'CheckAssignment',
    assignedHimself: 'assignedHimself',
    assignedBackToUser : 'assignedBackToUser',
}

export const AUTOASSIGN_STATUS = {
    APPROVED: 'Approved',
    CONDITIONAL_APPROVAL: 'Conditional Approval',
    CHANGE_REQUEST_ACCEPTED: 'Change Request - Accepted',
    CHANGE_REQUEST_REJECTED: 'Change Request - Rejected',
    CHANGE_REQUEST_PARTIALLY_ACCEPTED: 'Change Request - Partially Accepted',
    POST_APPLICATION_REVIEW_COMPLETE: 'Post Application Review Complete',
    PRICING_COMPLETE: 'Pricing Complete',
    DOCUMENTS_OUT: 'Documents Out',
    DOCUMENTS_BACK_INCOMPLETE: 'Documents Back - Incomplete',
    CREDIT_APPROVED:'Credit-Approved',
    CREDIT_CONDITIONAL_APPROVED:'Credit-Conditional Approved',
    CHANGE_REQUEST_ACCEPTED:'Change Request - Accepted',
    CHANGE_REQUEST_REJECTED:'Change Request - Rejected',
    POST_APPLICATION_REVIEW_COMPLETE:'Post Application Review Complete',
    PRICING_COMPLETE:'Pricing Complete',
    AUTO_DOCS_EMAILED_TO_PARTNER:'Auto Docs Emailed to Partner',
    DOCS_BACK_MISSING_INFORMATION:'Docs Back / Missing Information',
    EDOCS_SENT_TO_CUSTOMER: 'eDocs Sent to Customer',
}

